export { default } from './AccordionCDS';
